import React, { useState } from 'react';
import api from '../lib/api';
import '../styles/ai-theme.css';

export default function AdminBootstrapPage() {
  const [form, setForm] = useState({ username: '', email: '', password: '', setup_token: '' });
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setMsg(null); setErr(null);
    try {
      const res = await api.post(
        '/accounts/bootstrap-superadmin/',
        form,
        {
          // Bypass Authorization header *and* send setup token
          headers: {
            'X-Bypass-Auth': '1',
            'X-Setup-Token': form.setup_token,
          },
        }
      );
      setMsg(res.data.message || 'Superadmin created.');
    } catch (e2) {
      setErr(e2.response?.data?.detail || e2.response?.data || 'Failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ai-scope">
      <div className="ai-bg">
        <div className="center-screen">
          <div className="glass-card p-3 card-fixed">
            <div className="glass-header d-flex align-items-center justify-content-between">
              <h4 className="h-title m-0">Bootstrap Superadmin</h4>
              <span className="badge-soft">One-time setup</span>
            </div>
            <div className="p-3">
              <p className="h-subtle mb-3">Use the server’s setup token. This is a one-time action.</p>
              {msg && <div className="alert alert-success py-2">{String(msg)}</div>}
              {err && <div className="alert alert-danger py-2">{typeof err === 'string' ? err : JSON.stringify(err)}</div>}

              <form onSubmit={submit} className="d-grid gap-3">
                <input
                  className="form-control input-ai"
                  name="setup_token"
                  placeholder="Setup Token"
                  value={form.setup_token}
                  onChange={onChange}
                />
                <input
                  className="form-control input-ai"
                  name="username"
                  placeholder="Username"
                  value={form.username}
                  onChange={onChange}
                />
                <input
                  className="form-control input-ai"
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={form.email}
                  onChange={onChange}
                />
                <input
                  className="form-control input-ai"
                  type="password"
                  name="password"
                  placeholder="Password (min 8)"
                  value={form.password}
                  onChange={onChange}
                />

                <button className="btn-ai w-100" type="submit" disabled={loading}>
                  {loading ? 'Creating…' : 'Create Superadmin'}
                </button>
                <div className="d-flex gap-12">
                  <a className="btn-ai-ghost w-100 text-center" href="/">Back to site</a>
                  <a className="btn-ai-ghost w-100 text-center" href="/admin/login">Go to Login</a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
